export const description = {
  fontSize: 10,
};
